import { Box, BoxProps, Stack, StackProps, styled } from '@mui/material';

const StyledStack = styled(Stack)<StackProps>(() => ({
  display: 'flex',
  width: '100%',
  height: '4px',
  alignItems: 'center',
  gap: '4px',
  flex: '1 0 0',
  background: 'var(--grey-50, #252629)',
  borderRadius: 'var(--boarderRadius-1, 4px)',
}));

const StyledStackSegment = styled(Box)<BoxProps>(() => ({
  height: '100%',
  borderRadius: 'var(--boarderRadius-1, 4px)',
  transformOrigin: 'top left',
  animation: 'growSegment ease 1s',
  '@keyframes growSegment': {
    from: {
      width: '0',
    },
    to: {
      width: 'var(--finalWidth, 0)',
    },
  },
}));

type BarSegment = {
  value: number;
  color: string;
};

export const SegmentedBar = ({
  segments,
  fullBarValue,
}: {
  segments: BarSegment[];
  fullBarValue: number;
}) => {
  return (
    <StyledStack direction={'row'}>
      {segments.map(({ value, color }) => (
        <StyledStackSegment
          className='fadeOnHover'
          width={`${(value / fullBarValue) * 100}%`}
          sx={{
            backgroundColor: color,
            '--finalWidth': `${(value / fullBarValue) * 100}%`,
          }}
        />
      ))}
    </StyledStack>
  );
};
